import React from 'react'
import { Title, Description } from './ProfileModal.styles'
import {
  HeaderContainer,
  ContentContainer,
  Separator,
} from './ProfileDetailsStep.styles'
import { FormikProps } from 'formik'
import { Link } from '@sketch/components'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'
import { initialValues } from './form'
import { ProfileDetailsForm } from './ProfileDetailsForm'

interface CreateProfileDetailsStepProps {
  workspace: WorkspaceMinimalFragment
  formikBag: FormikProps<typeof initialValues>
}

export const CreateProfileDetailsStep = ({
  workspace,
  formikBag,
}: CreateProfileDetailsStepProps) => {
  return (
    <>
      <HeaderContainer>
        <Title>Profile Details</Title>
        <Description>
          This is the information people will see on your public profile, make
          it yours. Need help setting up your profile?{' '}
          <Link
            external
            href="https://www.sketch.com/redirect/web/public-profile-docs"
            target="_blank"
            variant="tertiary"
            isUnderlined
          >
            Check the documentation ↗
          </Link>
        </Description>
      </HeaderContainer>

      <Separator />

      <ContentContainer>
        <ProfileDetailsForm workspace={workspace} formikBag={formikBag} />
      </ContentContainer>
    </>
  )
}
